export const BOGO = 'bogo';
export const MSB = 'msb';
export const BMSM = 'bmsm';

export const PROMOTION_TYPES = [
  BOGO, MSB, BMSM,
];

export const MAX_NUM_TIERS_IN_PROMOTION = 5;
export const NUM_NON_GROUPED_TIERS = 3;
